import { render, staticRenderFns } from "./DotSolidIcon.vue?vue&type=template&id=6b42a916&"
import script from "./DotSolidIcon.vue?vue&type=script&lang=js&"
export * from "./DotSolidIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports